// extracted by mini-css-extract-plugin
module.exports = {"list":"storyliner-RT2pau"};